import {useSelector} from "react-redux";

export const COT_ROLE = "cot";
export const SECTIONAL_ROLE = "seccional";
export const PROMOTER_ROLE = "promotor";
export const DISTRICT_ROLE = "distrital";
export const STATE_ROLE = "estatal";
export const QUERY_STATE_ROLE = "consulta_estatal";
export const NATIONAL_ROLE = "nacional";

const useIsLoggedIn = () => {
    const auth = useSelector((state) => state.auth || {});
    return auth.hasOwnProperty('sessionId') && auth.sessionId !== null;
};

const useUserRole = () => {
    const auth = useSelector((state) => state.auth || {});
    return auth.user.roles.find((role) => /^(naci|consul|estat|distr|cot|secc|prom)/i.test(role.trim())) || "user";
};

const useUserSections = () => {
    const auth = useSelector((state) => state.auth || {});
    return auth.user?.route || auth.user?.sections || [];
};


export {useUserRole, useUserSections};

export default useIsLoggedIn;